import { render, staticRenderFns } from "./EvaluationDetails.vue?vue&type=template&id=8c5fe89a&"
import script from "./EvaluationDetails.vue?vue&type=script&lang=js&"
export * from "./EvaluationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports